import { useTheme } from "@mui/material";

export const useFirstColumnStickyStyles = () => {
    const theme = useTheme();
    return {
      "& .MuiDataGrid-cell": {
        borderBottom: "1px solid #e0e0e0",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: theme.palette.background.paper,
        borderBottom: `2px solid ${theme.palette.primary.main}`,
      },
      '.MuiDataGrid-cell[data-colindex="0"]': {
        position: "sticky",
        left: 0,
        boxShadow: "2px 0 5px -2px rgba(0,0,0,0.1)",
        backgroundColor: theme.palette.background.paper,
      },
    };
}